import store from 'store2';

export const SESSION_PRODUCT_NAME = 'productName';
export const SESSION_INSURER = 'insurer';
export const SESSION_PRODUCT = 'product';
export const SESSION_PLAN = 'plan';
export const SESSION_PRODUCT_TYPE = 'productType';
export const SESSION_APPLICATION_ID = 'applicationId';
export const SESSION_IS_RENEWAL = 'isRenewal';
export const SESSION_USE_OCR = 'useOcr';
export const SESSION_PDP_V2_INSURED_FORM_DATA = 'pdpV2InsuredFormData';
export const SESSION_RENEWAL_INFO = 'renewalInfo';
export const SESSION_REFERRAL_CODE = 'referralCode';
export const SESSION_FAST_QUOTE_RES = 'fastQuoteRes';

export const LOCAL_AB_TEST_VERSION = 'abTestVersion';
export const LOCAL_CLICK_EVENT_BUTTON_NAME = 'clickEventButtonName';
export const LOCAL_USER_INFO = 'B2C_USER_INFO';
export const LOCAL_APPLICATION_FORM_DATA = 'APPLICATION_FORM_DATA';
export const LOCAL_TOKEN = 'b2c_token';
export const LOCAL_RECENT_SEARCHES = 'travel_recent_searches';
export const LOCAL_LAST_TRIP_FORM_VALUES = 'travel_last_trip_form_values';
export const FIRST_TOOLTIP_VISIBLE = 'first_tooltip_visible';
export const LOCAL_COMPARE_PLANS = 'compare_plans';
export const LOCAL_REFERRAL_CODE = 'referralCode';
export const LOCAL_PLAN = 'plan';

const isBrowser = typeof window !== 'undefined';

const session = {
  setItem(key: string, value: any) {
    if (!isBrowser) return;
    store.session.set(key, value);
  },
  getItem(key: string) {
    if (!isBrowser) return;
    return store.session.get(key);
  },
  removeItem(key: string) {
    if (!isBrowser) return;
    store.session.remove(key);
  },
};

const local = {
  setItem(key: string, value: any) {
    if (!isBrowser) return;
    store.local.set(key, value);
  },
  getItem(key: string) {
    if (!isBrowser) return;
    return store.local.get(key);
  },
  removeItem(key: string) {
    if (!isBrowser) return;
    store.local.remove(key);
  },
};

const productLevelLocal = {
  setItem(key: string, value: any) {
    if (!isBrowser) return;
    const productName =
      session.getItem(SESSION_PRODUCT_NAME) ?? 'DEFAULT_PRODUCT';
    store.local.set(`${productName}_${key}`, value);
  },
  getItem(key: string) {
    if (!isBrowser) return;
    const productName =
      session.getItem(SESSION_PRODUCT_NAME) ?? 'DEFAULT_PRODUCT';
    return store.local.get(`${productName}_${key}`);
  },
  removeItem(key: string) {
    if (!isBrowser) return;
    const productName =
      session.getItem(SESSION_PRODUCT_NAME) ?? 'DEFAULT_PRODUCT';
    store.local.remove(`${productName}_${key}`);
  },
};

export { productLevelLocal, local, session };
